import { Component } from '@angular/core';

@Component({
  selector: 'app-open9-info-component',
  imports: [],
  templateUrl: './open9-info-component.html',
  styleUrl: './open9-info-component.scss'
})
export class Open9InfoComponent {

}
